module.exports = __webpack_public_path__ + "img/banner3_4_kr.fd75a304.png";